// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout Containers */
.flex-container {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
}

.flex-container.right-align {
  justify-content: flex-end;
}

.flex-container-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
}

/* Dropdown and Input Fields */
.dropdown {
  margin-left: -4px;
  padding: 4px;
  width: 105%;
  margin-top: -2rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  font-weight: normal;
}

.input-fields {
  margin-left: 3px;
  padding: 4px;
  width: 40%;
  margin-top: -1rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: medium;
  box-sizing: border-box;
  vertical-align: middle;
  font-weight: normal;
  color: black;
}

.input-field::placeholder {
  color: #808080;
  font-style: italic;
  font-size: medium;
  opacity: 0.8;
  font-weight: normal;
}

/* Typography and Spacing */
.text-light-text {
  --tw-text-opacity: 1;
  color: rgb(90 105 123 / var(--tw-text-opacity));
}

.mt15 {
  margin-top: 15px;
}

.mt-1rem {
  margin-top: 1rem;
}

/* Buttons */
.button-white-bg {
  background-color: white;
  color: #007BFF;
  border: 2px solid #007BFF;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: medium;
  transition: background-color 0.3s, color 0.3s;
  width: 20%;
}

/* Card */
.card {
  width: 100%;
  margin: 15px auto;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  overflow: hidden;
}

/* Table Styling */
#table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  width: 98%;
  margin-top: 1rem;
  padding-left: 4%;
}

#table th,
#table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

#table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

#table tr:nth-child(even) {
  background-color: #f9f9f9;
}

#table tr:hover {
  background-color: #e0e0e0;
}

/* Bordered Table */
.bordered-table table,
.bordered-table th,
.bordered-table td {
  border: 1px solid #ccc;
  border-collapse: collapse;
  padding: 8px;
  text-align: left;
}

.bordered-table th {
  position: sticky;
  top: 0;
  background: #f9f9f9;
  z-index: 1;
}

/* Scrollable Table Wrapper */
.table-scroll-wrapper {
  overflow-y: auto;
  max-height: 420px;
}

.flex-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
  font-size: medium;
  font-weight: bold;
  margin: 0.5rem 0;
}

.flex-container div {
  padding: 10px;
  text-align: left;
}

.flex-container.right-align {
  justify-content: flex-end;
}

.flex-container-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
}

.flex-container-button.right-align {
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: nowrap;
  margin-right: 10px;
}

.flex-container-button.right-align > div {
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
}

.dropdown {
  margin-left: -4px;
  padding: 4px;
  width: 105%;
  margin-top: -2rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  font-weight: normal;
}

.input-field,
.input-fields-so,
.input-fields.mafield,
.input-fields.store-order-nbr {
  padding: 4px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: medium;
  box-sizing: border-box;
  vertical-align: middle;
  font-weight: normal;
  color: black;
}

.input-field {
  margin-left: -3px;
  width: 15rem;
  margin-top: -2rem;
}

.input-fields-so {
  margin-left: -3px;
  width: 101%;
  margin-top: -2rem;
}

.input-fields.mafield {
  margin-left: -3px;
  width: 87%;
  margin-top: -2rem;
}

.input-fields.store-order-nbr {
  width: 331%;
}

.input-field::placeholder {
  color: #808080;
  font-style: italic;
  font-size: medium;
  opacity: 0.8;
}

.mt15 {
  margin-top: 15px;
}

.mt-1rem {
  margin-top: -1rem;
}

.margin-left {
  margin-left: 25px;
}

.margin-top-29px {
  margin-top: -29px;
}

.tab-color {
  font-size: 25px;
  padding: 25px;
}

.text-light-text {
  --tw-text-opacity: 1;
  color: rgb(90 105 123 / var(--tw-text-opacity));
}

.button-white-bg {
  background-color: white;
  color: #007BFF;
  border: 2px solid #007BFF;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: medium;
  transition: background-color 0.3s, color 0.3s;
  min-width: 166px;
}

.button-clear-bg {
  min-width: 166px;
}

.custom-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-popup {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 300px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.inner-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.popup-heading {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.ok-button {
  background-color: #2e7d32;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.ok-button:hover {
  background-color: #1b5e20;
}

.cancel-button {
  background-color: #795548;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #5d4037;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  margin-left: 12px;
  cursor: pointer;
}

.notification {
  position: fixed;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 20px;
  border-radius: 4px;
  color: #fff;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 300px;
  max-width: 90%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.notification.success {
  background-color: #e6f4ea;
  color: #1e4620;
  border: 1px solid #a5d6a7;
}

.notification.error {
  background-color: #fdecea;
  color: #611a15;
  border: 1px solid #f5c6cb;
}

.notification.success .close-btn {
  color: #1e4620;
}

.notification.error .close-btn {
  color: #611a15;
}

.file-name {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #333;
}

.upload-button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.file-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.delete-icon {
  cursor: pointer;
  color: #d9534f;
  font-size: 1.2rem;
  -webkit-user-select: none;
          user-select: none;
  padding: 0 6px;
  margin-top: -32px;
}
.error-message {
  color: red;
  font-size: 0.9rem;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/tab/StoreOrderHistory/StoreOrderHistoryTab.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;;;EAGE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["/* Layout Containers */\n.flex-container {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.flex-container.right-align {\n  justify-content: flex-end;\n}\n\n.flex-container-button {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem 0;\n}\n\n/* Dropdown and Input Fields */\n.dropdown {\n  margin-left: -4px;\n  padding: 4px;\n  width: 105%;\n  margin-top: -2rem;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  font-weight: normal;\n}\n\n.input-fields {\n  margin-left: 3px;\n  padding: 4px;\n  width: 40%;\n  margin-top: -1rem;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: medium;\n  box-sizing: border-box;\n  vertical-align: middle;\n  font-weight: normal;\n  color: black;\n}\n\n.input-field::placeholder {\n  color: #808080;\n  font-style: italic;\n  font-size: medium;\n  opacity: 0.8;\n  font-weight: normal;\n}\n\n/* Typography and Spacing */\n.text-light-text {\n  --tw-text-opacity: 1;\n  color: rgb(90 105 123 / var(--tw-text-opacity));\n}\n\n.mt15 {\n  margin-top: 15px;\n}\n\n.mt-1rem {\n  margin-top: 1rem;\n}\n\n/* Buttons */\n.button-white-bg {\n  background-color: white;\n  color: #007BFF;\n  border: 2px solid #007BFF;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: medium;\n  transition: background-color 0.3s, color 0.3s;\n  width: 20%;\n}\n\n/* Card */\n.card {\n  width: 100%;\n  margin: 15px auto;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  overflow: hidden;\n}\n\n/* Table Styling */\n#table {\n  border: 1px solid #ccc;\n  border-collapse: collapse;\n  width: 98%;\n  margin-top: 1rem;\n  padding-left: 4%;\n}\n\n#table th,\n#table td {\n  border: 1px solid #ccc;\n  padding: 8px;\n  text-align: left;\n}\n\n#table th {\n  background-color: #f4f4f4;\n  font-weight: bold;\n}\n\n#table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n#table tr:hover {\n  background-color: #e0e0e0;\n}\n\n/* Bordered Table */\n.bordered-table table,\n.bordered-table th,\n.bordered-table td {\n  border: 1px solid #ccc;\n  border-collapse: collapse;\n  padding: 8px;\n  text-align: left;\n}\n\n.bordered-table th {\n  position: sticky;\n  top: 0;\n  background: #f9f9f9;\n  z-index: 1;\n}\n\n/* Scrollable Table Wrapper */\n.table-scroll-wrapper {\n  overflow-y: auto;\n  max-height: 420px;\n}\n\n.flex-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 2rem;\n  font-size: medium;\n  font-weight: bold;\n  margin: 0.5rem 0;\n}\n\n.flex-container div {\n  padding: 10px;\n  text-align: left;\n}\n\n.flex-container.right-align {\n  justify-content: flex-end;\n}\n\n.flex-container-button {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem 0;\n}\n\n.flex-container-button.right-align {\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: nowrap;\n  margin-right: 10px;\n}\n\n.flex-container-button.right-align > div {\n  display: flex;\n  gap: 10px;\n  flex-wrap: nowrap;\n}\n\n.dropdown {\n  margin-left: -4px;\n  padding: 4px;\n  width: 105%;\n  margin-top: -2rem;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  font-weight: normal;\n}\n\n.input-field,\n.input-fields-so,\n.input-fields.mafield,\n.input-fields.store-order-nbr {\n  padding: 4px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: medium;\n  box-sizing: border-box;\n  vertical-align: middle;\n  font-weight: normal;\n  color: black;\n}\n\n.input-field {\n  margin-left: -3px;\n  width: 15rem;\n  margin-top: -2rem;\n}\n\n.input-fields-so {\n  margin-left: -3px;\n  width: 101%;\n  margin-top: -2rem;\n}\n\n.input-fields.mafield {\n  margin-left: -3px;\n  width: 87%;\n  margin-top: -2rem;\n}\n\n.input-fields.store-order-nbr {\n  width: 331%;\n}\n\n.input-field::placeholder {\n  color: #808080;\n  font-style: italic;\n  font-size: medium;\n  opacity: 0.8;\n}\n\n.mt15 {\n  margin-top: 15px;\n}\n\n.mt-1rem {\n  margin-top: -1rem;\n}\n\n.margin-left {\n  margin-left: 25px;\n}\n\n.margin-top-29px {\n  margin-top: -29px;\n}\n\n.tab-color {\n  font-size: 25px;\n  padding: 25px;\n}\n\n.text-light-text {\n  --tw-text-opacity: 1;\n  color: rgb(90 105 123 / var(--tw-text-opacity));\n}\n\n.button-white-bg {\n  background-color: white;\n  color: #007BFF;\n  border: 2px solid #007BFF;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: medium;\n  transition: background-color 0.3s, color 0.3s;\n  min-width: 166px;\n}\n\n.button-clear-bg {\n  min-width: 166px;\n}\n\n.custom-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-popup {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 8px;\n  min-width: 300px;\n  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n.inner-box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.popup-heading {\n  margin-top: 0;\n  margin-bottom: 12px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n}\n\n.popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.ok-button {\n  background-color: #2e7d32;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ok-button:hover {\n  background-color: #1b5e20;\n}\n\n.cancel-button {\n  background-color: #795548;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.cancel-button:hover {\n  background-color: #5d4037;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  margin-left: 12px;\n  cursor: pointer;\n}\n\n.notification {\n  position: fixed;\n  top: 70px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 12px 20px;\n  border-radius: 4px;\n  color: #fff;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 300px;\n  max-width: 90%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.notification.success {\n  background-color: #e6f4ea;\n  color: #1e4620;\n  border: 1px solid #a5d6a7;\n}\n\n.notification.error {\n  background-color: #fdecea;\n  color: #611a15;\n  border: 1px solid #f5c6cb;\n}\n\n.notification.success .close-btn {\n  color: #1e4620;\n}\n\n.notification.error .close-btn {\n  color: #611a15;\n}\n\n.file-name {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.upload-button-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.file-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.delete-icon {\n  cursor: pointer;\n  color: #d9534f;\n  font-size: 1.2rem;\n  user-select: none;\n  padding: 0 6px;\n  margin-top: -32px;\n}\n.error-message {\n  color: red;\n  font-size: 0.9rem;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
